<template>
  <div id="app">
    <Grid class="subpixel-antialiased" />
  </div>
</template>

<script>
import Grid from "./components/Grid.vue"
import Vue from "vue"
import { mapActions, mapState, mapMutations } from "vuex"

export default {
  name: "SmartQ",
  components: {
    Grid,
  },
  computed: {
    ...mapState({
      isOffline: (state) => state.app.isOffline,
      isActive: (state) => state.live.isActive,
      question: (state) => state.question,
      stack: (state) => state.offline.stack
    }),
  },
  methods: {
    ...mapActions({
      initStore: "app/initStore",
      connect: "socketppt/connect",
      retrieveGridOptions: "grid/setOptionsFromSaved",
      disconnect: "socket/disconnect",
    }),
    ...mapMutations({
      launchQuestion: "live/launchQuestion",
      setInactive: "live/setInactive",
    }),
    handleOffline() {
      // Check if the question is launched
      if (this.isOffline === false && this.isActive === true) {
        this.disconnect()
      }
    },
    handleOnline() {
      // Check if the question is launched
      if (this.isOffline === true && this.isActive === true) {
        // this.setInactive()
        // Unstack offline modifications and sync question / answers / labels from DB
        this.launchQuestion({ sync: false, refresh: (this.stack.length > 0) })
      }
    },
  },
  async created() {
    console.log("App created...")
    await this.retrieveGridOptions()
    // PPT ws connection
    if (window.Office) {
      this.connect()
    } else {
      this.initStore()
    }

    // Internet connection loss management
    window.addEventListener("offline", this.handleOffline)
    window.addEventListener("online", this.handleOnline)
  },
  destroyed() {
    window.removeEventListener("offline", this.handleOffline)
    window.removeEventListener("online", this.handleOnline)
  },
}
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
